import React from 'react'
import GeoentityHotelListItemDetails from './GeoentityHotelListItemDetails'
import GeoentityGenericListItemDetails from './GeoentityGenericListItemDetails'
import { GEOENTITY_HOTEL_CELL_TYPE } from '../../store/geoentity/geoentity.constants'
import useGetGeoentityTypeForListItem from './useGetGeoentityTypeForListItem'
const GeoentityListItemDetails = ({ noExternalButtons, poi }) => {
  const type = useGetGeoentityTypeForListItem(poi)

  switch (type) {
    case GEOENTITY_HOTEL_CELL_TYPE:
      return <GeoentityHotelListItemDetails poi={poi} noExternalButtons={noExternalButtons} />
    default:
      return <GeoentityGenericListItemDetails poi={poi} noExternalButtons={noExternalButtons} />
  }
}

export default GeoentityListItemDetails
